import { ICalloutPositionStyles } from './callout-types';

export const defaultProps = {
    animateOnOpen: true,
    beakWidth: 16,
    offset: 0
};

export const getDefaultPositionStyles = (useFullHeight?: boolean, useFullWidth?: boolean): ICalloutPositionStyles => ({
    layerStyles: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    contentPositionStyles: {
        maxHeight: useFullHeight ? '100%' : '95%',
        maxWidth: useFullWidth ? '100%' : '95%'
    },
    beakStyles: {
        display: 'none'
    }
});
